import { Box } from "@mui/material";
import {
  DataGridPro,
  GridFooterContainer,
  GridPagination,
} from "@mui/x-data-grid-pro";

import themeInarix from "../../StylesMuiInarix";
import { ThemeProvider } from "@mui/material/styles";
import TableMiniChartColumns from "./FetchingColumnsMiniChart";

export function DashboardTable(t: (arg0: string) => string, locale: string) {
  const { columnsValues, mapResults } = TableMiniChartColumns(t);

  const paginationToolbar = () => {
    return (
      <GridFooterContainer
        sx={{ alignItems: "flex-start", justifyContent: "flex-start" }}
      >
        <GridPagination labelRowsPerPage={t("Dashboard.Users_per_page")} />
      </GridFooterContainer>
    );
  };

  return (
    <Box sx={{ height: 400, width: "100%", maxWidth: 380 }}>
      <ThemeProvider theme={themeInarix(locale)}>
        <DataGridPro
          rows={mapResults}
          columns={columnsValues}
          pageSizeOptions={[50]}
          slots={{ footer: paginationToolbar }}
          initialState={{
            pagination: { paginationModel: { pageSize: 50 } },
          }}
          rowHeight={20}
          sx={{
            border: "none",
            fontSize: "0.75rem",
            "& .MuiDataGrid-cell": {
              fontSize: "0.7rem",
              padding: "2px 4px",
            },
            "& .MuiDataGrid-columnHeader": {
              fontSize: "0.7rem",
              padding: "2px 4px",
              minHeight: "28px !important",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: "0.7rem",
              fontWeight: 500,
            },
            "& .MuiDataGrid-footerContainer": {
              minHeight: "35px",
            },
            "& .MuiTablePagination-root": {
              fontSize: "0.65rem",
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
              {
                fontSize: "0.65rem",
              },
          }}
        />
      </ThemeProvider>
    </Box>
  );
}
